module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_miyakojima_plans-ea0fe9a08b644660d84f5586bae71f65.jpg";